import { TPlateEditor } from '@udecode/plate-common/react'
import { Mention } from 'use-towns-client'

import { getMentions, getSlashCommand } from '../components/plate-ui/autocomplete/helpers'
import {
    TSlashCommandElement,
    TUserMentionElement,
} from '../components/plate-ui/autocomplete/types'

import { serialize } from './remark'

export const toMD = (
    editor: TPlateEditor,
): Promise<{
    message: string
    mentions: Mention[]
    slashCommand?: TSlashCommandElement
}> => {
    return new Promise((resolve, reject) => {
        queueMicrotask(() => {
            try {
                const markdown = editor.children
                    .map((child) => serialize(child))
                    .join('')
                    .trim()
                resolve({
                    message: markdown,
                    mentions: getMentions(editor.children as TUserMentionElement[]),
                    slashCommand: getSlashCommand(editor.children as TUserMentionElement[]),
                })
            } catch (err) {
                console.log('[ERROR] Plate -> MD', err)
                reject({ message: '', mentions: [], slashCommand: undefined })
            }
        })
    })
}
